module.exports = __webpack_public_path__ + "img/assertiveness_distractYourself.0150c06a.png";